import * as z from "zod";

export const RunReportSchema = z.object({
  type: z.string(),
  sources: z.array(z.string()),
  date: z.date(),
});

export type RunReportType = z.infer<typeof RunReportSchema>;
